module.exports = __webpack_public_path__ + "static/fonts/Modern Deco.e33bddab.ttf";